import axios from 'axios'

export default {
    namespaced: true,
    state: {
        forms: [],
        form: {},
        formPages: [],
        formPage: {},
        formPageSections: [],
        formQuestions: [],
        formQuestionDocuments: [],
        formQuestionHelp: [],
        formQuestionSubHelp: [],
    },
    mutations: {
        SET_FORMS(state, payload) {
            state.forms = payload;
        },
        SET_FORM(state, payload) {
            state.form = payload;
        },
        SET_FORM_PAGES(state, payload) {
            state.formPages = payload;
        },
        SET_FORM_PAGE(state, payload) {
            state.formPage = payload;
        },
        SET_FORM_PAGE_SECTIONS(state, payload) {
            state.formPageSections = payload;
        },
        SET_FORM_QUESTIONS(state, payload) {
            state.formQuestions = payload;
        },
        SET_FORM_QUESTION_DOCUMENTS(state, payload) {
            state.formQuestionDocuments = payload;
        },
        SET_FORM_QUESTION_HELP(state, payload) {
            state.formQuestionHelp = payload;
        },
        SET_FORM_QUESTION_SUB_HELP(state, payload) {
            state.formQuestionSubHelp = payload;
        },
    },
    actions: {
        FetchForms({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/fetch`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORMS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchForms: ${error.message}`));
            });
        },
        FetchFormsByAcademicSession({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/fetch/academic-session/${obj.academicSession}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORMS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormsByAcademicSession: ${error.message}`));
            });
        },
        FetchFormByTypeAcademicSession({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/fetch/type/${obj.type}/academic-session/${obj.academicSession}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORM', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormByTypeAcademicSession: ${error.message}`));
            });
        },
        FetchFormPagesByFormID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/pages/fetch/form-id/${obj.formID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORM_PAGES', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormPagesByFormID: ${error.message}`));
            });
        },
        FetchFormPageByFormSlugPageSlug({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/pages/fetch/form/${obj.formSlug}/page/${obj.pageSlug}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORM_PAGE', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormPageByFormSlugPageSlug: ${error.message}`));
            });
        },
        FetchFormPageSectionsByFormID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/sections/fetch/form-id/${obj.formID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORM_PAGE_SECTIONS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormPageSectionsByFormID: ${error.message}`));
            });
        },
        FetchFormPageSectionsByFormPageID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/sections/fetch/form-page-id/${obj.formPageID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORM_PAGE_SECTIONS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormPageSectionsByFormPageID: ${error.message}`));
            });
        },
        FetchFormQuestionsByFormID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/questions/fetch/form-id/${obj.formID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            if (!!response.data.payload) {
                                response.data.payload.forEach(fq => {
                                    fq.options = CoalesceJSON(fq.options);
                                });
                            }
                            commit('SET_FORM_QUESTIONS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormQuestionsByFormID: ${error.message}`));
            });
        },
        FetchFormQuestionsByFormPageID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/questions/fetch/form-page-id/${obj.formPageID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            if (!!response.data.payload) {
                                response.data.payload.forEach(fq => {
                                    fq.options = CoalesceJSON(fq.options);
                                });
                            }
                            commit('SET_FORM_QUESTIONS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormQuestionsByFormPageID: ${error.message}`));
            });
        },
        FetchFormQuestionDocumentsByFormPageID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/documents/fetch/form-page-id/${obj.formPageID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORM_QUESTION_DOCUMENTS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormQuestionDocumentsByFormPageID: ${error.message}`));
            });
        },
        FetchFormQuestionHelpByFormPageID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/help/fetch/form-page-id/${obj.formPageID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORM_QUESTION_HELP', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormQuestionHelpByFormPageID: ${error.message}`));
            });
        },
        FetchFormQuestionSubHelpByFormPageID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/forms/help/sub/fetch/form-page-id/${obj.formPageID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FORM_QUESTION_SUB_HELP', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFormQuestionSubHelpByFormPageID: ${error.message}`));
            });
        },
    },
    getters: {
        Forms(state) { return state.forms; },
        Form(state) { return state.form; },
        FormPages(state) { return state.formPages; },
        FormPage(state) { return state.formPage; },
        FormPageSections(state) { return state.formPageSections; },
        FormQuestions(state) { return state.formQuestions; },
        FormQuestionDocuments(state) { return state.formQuestionDocuments; },
        FormQuestionHelp(state) { return state.formQuestionHelp; },
        FormQuestionSubHelp(state) { return state.formQuestionSubHelp; },
    }
};

function CoalesceJSON(object, returnObject) {
    if (object == null || object == '' || typeof(object) == "undefined") return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
